import PostedJobs from "./PostedJobs.vue";

export default PostedJobs;
